import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TranslationKeys } from '../../../../locale/localizationContext';
import { useLanguage } from '../../../../locale/useLanguage';
import { setErrorDescription } from '../../../../redux/general/general.actions';
import { getErrorDescriptionSelector } from '../../../../redux/general/general.selectors';
import { Button } from '../../../Button/Button';
import { Modal, ModalRef } from '../../../Modal/Modal';

type ErrorModalProps = {};

export const ErrorModal: React.FC<ErrorModalProps> = () => {
  const [t] = useLanguage();
  const dispatch = useDispatch();
  const modalRef = useRef<ModalRef>(null);

  const errorDescription = useSelector(
    getErrorDescriptionSelector
  ) as TranslationKeys<string> | null;

  useEffect(() => {
    if (errorDescription) {
      modalRef.current?.openModal();
    }
  }, [errorDescription]);

  const onCloseModal = useCallback(() => {
    setTimeout(() => {
      dispatch(setErrorDescription(null));
    }, 500);
  }, [dispatch]);

  const closeModal = useCallback(() => {
    modalRef.current?.closeModal();
    onCloseModal();
  }, [onCloseModal]);

  return (
    <Modal ref={modalRef} onClose={onCloseModal}>
      <h3 className="modal-title">{t('errorModal.modalTitle')}</h3>
      {errorDescription && (
        <p className="modal-description">{t(errorDescription)}</p>
      )}
      <div className="modal-button-container">
        <Button
          onClick={closeModal}
          label={t('errorModal.modalCloseButton')}
          isPrimary
        />
      </div>
    </Modal>
  );
};
